import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CustomSelectComponent),
    multi: true
};

@Component({
    selector: 'custom-select',
    template: `
        <div class="custom-select" (click)="toggleSelect($event)" [ngClass]="{'opened': isOpened}">
            <span>{{placeholder}}</span> 
        </div>
        <div class="custom-options" *ngIf="isOpened">
            <div class="custom-option-row" *ngFor="let item of options" [attr.data-selected]="item.selected" (click)="selectOption(item)">
                <span [attr.data-optid]="item.id" (click)="selectOption(item)">{{item.name}}</span>
            </div>
        </div>
    `,
    host:{
        "[attr.value]": "option?.id || -1"
    },
    styles: [`
        :host{
            display: inline-block;
            position:relative;
        }
        .custom-select{
            width: 100%;
            height: 100%;
            cursor: pointer;
            display: block;
            height: 34px;
            line-height: 34px;
        }
        .custom-select span{
            padding: 8px 0 8px 12px;
        }
        .custom-select::after{
            font-family: 'Material Icons';
            content: 'keyboard_arrow_down';
            float: right;
            font-size: 20px;
        }
        .custom-select.opened::after{
            content: 'keyboard_arrow_up';            
        }
        .custom-options{
            background: #fafafa;
            margin: 0px;
            padding: 0 8px;
            box-shadow: 4px 8px 20px 0px #1c1818;
            position: absolute;
            overflow: auto;
            width: calc(100% - 16px);
            z-index: 999;
            max-height: 170px;
        }
        @media (max-width: 839px){
            .custom-options{
                position: fixed;
                top: 30px;
                max-height: calc(100% - 60px);
                height: auto;
                left: 8px;
                width: calc(100% - 32px);
            }
        }

        .custom-option-row{
            cursor: pointer;
            margin: 0 -8px;
            height: 34px;
            padding: 0 22px;
            line-height: 34px;            
        }
        
        .custom-option-row[data-selected='true']:before{
            content: 'done';
            position: absolute;
            left: 4px;
            height: 16px;
            width: 16px;
            font-family: 'Material Icons';
            font-weight: bold;
            font-size: 16px;
        }
        .custom-option-row:hover, .custom-option-row[data-selected='true']{
            background-color: #8f8f8f;
            color: #fff;
        }

        @media (max-width: 839px){
           .custom-option-row{
                margin: 0 -8px;
                height: 64px;
                padding: 0 32px;
                line-height: 64px;            
            }
            .custom-option-row[data-selected='true']:before{
                left: 8px;
                height: 24px;
                width: 24px;
                font-size: 24px;
            }
        }
    `],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class CustomSelectComponent implements OnChanges {
    // Working NgModel
    public _option:any;
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    get option(): any {
        return this._option;
    };

    set option(v: any) {
        if (v !== this._option) {
            this._option = v;
            this.onChangeCallback(v);
        }
    }

    writeValue(value: any) {
        if (value !== this._option) {
            this._option = value;
        }
    }

    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    // -------------- Component features ----------------- //
    public isOpened:boolean = false;
    @Input() public placeholder:string;
    @Input() public options:any[];
    @Output() public onOpen:EventEmitter<any>;
    @Output() public onClose:EventEmitter<any>;    
    @Output() public onSelect:EventEmitter<any>
    
    

    constructor(){
        this.onOpen = new EventEmitter();
        this.onClose = new EventEmitter();
        this.onSelect = new EventEmitter();
    }

    ngOnChanges(changes:SimpleChanges){
        if(this.options != null){
            let size = this.options.length;
            let optionSelected = this.options.find(option => {
                return option.selected == true || size == 1;
            });
            if(optionSelected != null){
                this.placeholder = optionSelected.name;
                this.option = optionSelected;
            }
        } 
    }

    toggleSelect($event:any) {
        this.isOpened = !this.isOpened;
        if(this.isOpened){
            this.onOpen.emit();
        }else{
            this.onClose.emit();
        }
    }

    selectOption(item:any){
        this.options.forEach(opt => {
            opt.selected = false;
        });
        item.selected = true;
        this.option = item;
        this.isOpened = false;
        this.placeholder = item.name;
        this.onSelect.emit(item);
    }
}